import {Component, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID} from '@angular/core';
import {Stream} from '../types/stream';
import {UserService} from '../services/user_service';
import {StreamService} from '../services/stream_service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ActivatedRoute, Router} from '@angular/router';


@Component({
  selector: 'stream',
  templateUrl: './stream-view.component.html',
  styleUrls: ['./stream-view.component.scss']
})
export class StreamViewComponent implements OnInit {
  @Input()
  public stream: Stream;

  @Input()
  public view?: string;

  @Input()
  public buttons: {type: string; title: string}[];

  @Output()
  public actionButtonCallback: EventEmitter<{type: string; streamId: string | number}> = new EventEmitter();

  public streamDescriptionLimited: string | null;
  noteThumb = '';

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected userService: UserService,
    protected streamService: StreamService,
    protected modalService: NgbModal,
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) protected platformId: Object) { }


  public ngOnInit(): void {
    if (this.stream.description.length > 100) {
      this.streamDescriptionLimited = this.reduceText(this.stream.description, 125);
    }
  }

  public buttonClickEvent(type: string): void {
    this.actionButtonCallback.emit({
      type,
      streamId: this.stream.id
    });
  }

  

  // setThumbnail() {
  //   if (this.note.thumbnails && this.note.thumbnails[300]) {
  //     this.noteThumb = this.note.thumbnails[300];
  //   } else if (this.note.thumbnails && this.note.thumbnails[600]) {
  //     this.noteThumb = this.note.thumbnails[600];
  //   } else {
  //     this.noteThumb = this.note.thumbnailImage;
  //   }

  //   if (isPlatformBrowser(this.platformId) && this.noteThumb) {
  //     const thumbImg = new Image(); // only on browser
  //     thumbImg.src = this.noteThumb;
  //     thumbImg['onload'] = () => {
  //       this.ratioThumb = (thumbImg.naturalWidth / thumbImg.naturalHeight) > 2.4 ? false : true;
  //     };
  //   }
  // }

  private reduceText(text: string, limit: number): string {
    return text.split(' ').slice(0, limit).join(' ')  + '...';
  }

  private getThumb(thumbQualityArray: any): string {
    let maxQ = 0;
    let bestThumb: any;

    for (const [key, value] of Object.entries(thumbQualityArray)) {
      const keyV = parseInt(key, 10);
      if (maxQ < keyV) {
        maxQ = keyV;
        bestThumb = value;
      }
    }

    return bestThumb;
  }
}
